import { IconColor, IconName } from 'components/Icon';

const notRosteredColor: IconColor = 'percussion';
const notRosteredIcon: IconName = 'link-unlinked';
const notRosteredLabel = 'Not SIS linked';
const rosteredColor: IconColor = 'atlas';
const rosteredIcon: IconName = 'link-linked';
const rosteredLabel = 'Linked to SIS';

export default {
  notRosteredColor,
  notRosteredIcon,
  notRosteredLabel,
  rosteredColor,
  rosteredIcon,
  rosteredLabel,
};
